(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pip-about-hero"] && !Shopify.designMode) return;
  try {
    
  const hydratePipAboutVideo = (root) => {
    if (root.dataset.aboutVideoReady === 'true') return;
    const video = root.querySelector('video');
    const play = root.querySelector('[data-about-play]');
    const state = root.querySelector('[data-about-play-state]');
    const progress = root.querySelector('[data-about-progress]');
    if (!video || !play || !state || !progress) return;
    root.dataset.aboutVideoReady = 'true';
    const sync = () => {
      state.textContent = video.paused ? '▶' : '❚❚';
      play.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
      if (Number.isFinite(video.duration) && video.duration > 0) {
        progress.value = String(Math.round((video.currentTime / video.duration) * 1000));
      }
    };
    play.addEventListener('click', () => {
      if (video.paused) video.play();
      else video.pause();
    });
    progress.addEventListener('input', () => {
      if (Number.isFinite(video.duration) && video.duration > 0) {
        video.currentTime = (Number(progress.value) / 1000) * video.duration;
      }
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('timeupdate', sync);
    video.addEventListener('loadedmetadata', sync);
    sync();
  };
  document.querySelectorAll('[data-pip-about-video]').forEach(hydratePipAboutVideo);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-pip-about-video]');
    if (root) hydratePipAboutVideo(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pip-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  class PipBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => this.handleClick(event));
      this.addEventListener('submit', (event) => this.handleSubmit(event));
      this.sync();
    }

    get rows() {
      return Array.from(this.querySelectorAll('[data-bundle-item]'));
    }

    get targetQuantity() {
      const selectedSize = this.querySelector('[data-bundle-size][aria-pressed="true"]');
      return Number(selectedSize?.dataset.bundleSize || 4);
    }

    get totalQuantity() {
      return this.rows.reduce((total, row) => total + Number(row.dataset.quantity || 0), 0);
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;

      const sizeButton = event.target.closest('[data-bundle-size]');
      if (sizeButton && this.contains(sizeButton)) {
        this.selectSize(sizeButton);
        return;
      }

      const quantityButton = event.target.closest('[data-bundle-action]');
      if (!quantityButton || !this.contains(quantityButton)) return;

      const row = quantityButton.closest('[data-bundle-item]');
      if (!row) return;

      const currentQuantity = Number(row.dataset.quantity || 0);
      if (quantityButton.dataset.bundleAction === 'increase') {
        if (this.totalQuantity >= this.targetQuantity) {
          this.setMessage(`This ${this.targetQuantity}-bag bundle is already full.`, true);
          return;
        }
        this.setRowQuantity(row, currentQuantity + 1);
      } else {
        this.setRowQuantity(row, Math.max(0, currentQuantity - 1));
      }

      this.setMessage('');
      this.sync();
    }

    selectSize(sizeButton) {
      this.querySelectorAll('[data-bundle-size]').forEach((button) => {
        const isSelected = button === sizeButton;
        button.setAttribute('aria-pressed', String(isSelected));
        button.classList.toggle('is-active', isSelected);
      });

      if (this.totalQuantity > this.targetQuantity) {
        this.rows.forEach((row) => this.setRowQuantity(row, 0));
        this.setMessage(`Choose ${this.targetQuantity} snacks for your new bundle size.`);
      } else {
        this.setMessage('');
      }

      this.sync();
    }

    setRowQuantity(row, quantity) {
      const safeQuantity = Math.max(0, quantity);
      row.dataset.quantity = String(safeQuantity);
      row.classList.toggle('is-selected', safeQuantity > 0);
      const output = row.querySelector('[data-bundle-quantity]');
      if (output) {
        output.value = String(safeQuantity);
        output.textContent = String(safeQuantity);
      }
    }

    sync() {
      const total = this.totalQuantity;
      const target = this.targetQuantity;
      const remaining = Math.max(0, target - total);
      const progress = this.querySelector('[data-bundle-progress]');
      const submitButton = this.querySelector('[data-bundle-submit]');

      if (progress) {
        progress.textContent = remaining === 0
          ? `Bundle ready: ${total} of ${target} bags selected.`
          : `${total} of ${target} bags selected. Choose ${remaining} more.`;
      }

      this.rows.forEach((row) => {
        const quantity = Number(row.dataset.quantity || 0);
        const decreaseButton = row.querySelector('[data-bundle-action="decrease"]');
        const increaseButton = row.querySelector('[data-bundle-action="increase"]');
        if (decreaseButton) decreaseButton.disabled = quantity === 0 || this.busy;
        if (increaseButton) increaseButton.disabled = total >= target || this.busy;
      });

      if (submitButton) {
        submitButton.disabled = this.rows.length === 0 || total !== target || this.busy;
      }
    }

    setMessage(text, isError = false) {
      const message = this.querySelector('[data-bundle-message]');
      if (!message) return;
      message.hidden = !text;
      message.textContent = text;
      message.classList.toggle('pip-bundle__error', isError);
      message.setAttribute('role', isError ? 'alert' : 'status');
      message.setAttribute('aria-live', isError ? 'assertive' : 'polite');
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (this.busy) return;

      const target = this.targetQuantity;
      const items = this.rows
        .map((row) => ({
          id: row.dataset.variantId,
          quantity: Number(row.dataset.quantity || 0),
          properties: { '_Pip Bundle': `${target} bags` },
        }))
        .filter((item) => item.id && item.quantity > 0);
      const itemCount = items.reduce((total, item) => total + item.quantity, 0);

      if (itemCount !== target) {
        this.setMessage(`Select exactly ${target} bags before adding this bundle.`, true);
        this.sync();
        return;
      }

      const submitButton = this.querySelector('[data-bundle-submit]');
      const defaultLabel = submitButton?.textContent.trim() || 'Add bundle to cart';
      const loadingLabel = submitButton?.dataset.loadingLabel || 'Adding bundle...';
      this.busy = true;
      if (submitButton) {
        submitButton.textContent = loadingLabel;
        submitButton.setAttribute('aria-busy', 'true');
      }
      this.setMessage('Adding your bundle to the cart.');
      this.sync();

      try {
        const root = window.Shopify?.routes?.root || '/';
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((component) => component.dataset.sectionId)
          .filter(Boolean);
        const uniqueSectionIds = [...new Set(sectionIds)];
        const payload = {
          items,
          sections_url: window.location.pathname,
        };
        if (uniqueSectionIds.length > 0) payload.sections = uniqueSectionIds.join(',');

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          const responseMessage = typeof result.description === 'string'
            ? result.description
            : result.message;
          throw new Error(responseMessage || 'This bundle could not be added. Please try again.');
        }

        let cart = {};
        try {
          const cartResponse = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
          });
          if (cartResponse.ok) cart = await cartResponse.json();
        } catch (cartError) {
          cart = {};
        }

        this.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: this.id,
            data: {
              source: 'pip-bundle-builder',
              itemCount,
              sections: result.sections || {},
            },
          },
        }));

        this.rows.forEach((row) => this.setRowQuantity(row, 0));
        this.setMessage('Your bundle was added to the cart.');
      } catch (error) {
        const message = error instanceof Error ? error.message : 'This bundle could not be added. Please try again.';
        this.setMessage(message, true);
      } finally {
        this.busy = false;
        if (submitButton) {
          submitButton.textContent = defaultLabel;
          submitButton.removeAttribute('aria-busy');
        }
        this.sync();
      }
    }
  }

  if (!customElements.get('pip-bundle-builder')) {
    customElements.define('pip-bundle-builder', PipBundleBuilder);
  }

  } catch(e) { console.error(e); }
})();
})();
